const MEDIA_URL = "https://media.sportsx9.com";

export default MEDIA_URL;
